// extracted by mini-css-extract-plugin
export var bubble = "_2x-0";
export var container = "_2x-3";
export var contrastBorder = "_2x-4";
export var greyOut = "_2x-2";
export var initialsWrapper = "_2x-1";
export var large = "_2x-9";
export var medium = "_2x-8";
export var mediumSmall = "_2x-7";
export var mediumSmallMedium = "_2x-c";
export var micro = "_2x-5";
export var small = "_2x-6";
export var tiny = "_2x-b";
export var xTiny = "_2x-a";